import { Drawer } from '@templates/index';
import { useUiStore } from '@store/index';
import { TuningPanel } from './TuningPanel';

/**
 * Left-slide drawer dedicated to string/scale/tuning configuration.
 *
 * Uses a transparent backdrop — the player tunes by hearing what they
 * play, which means they must see the strings with perfect clarity
 * while the drawer is open.
 */
export function TuningDrawer() {
  const open = useUiStore((s) => s.tuningOpen);
  const setOpen = useUiStore((s) => s.setTuningOpen);
  const toggle = useUiStore((s) => s.toggleTuning);

  return (
    <Drawer
      open={open}
      onClose={() => setOpen(false)}
      onToggle={toggle}
      title="Tuning"
      side="left"
      width="min(420px, 94vw)"
      backdrop="transparent"
      shortcut="t"
      hint={
        <>
          <kbd>T</kbd> toggle · <kbd>Esc</kbd> close
        </>
      }
    >
      <TuningPanel />
    </Drawer>
  );
}
